export default __webpack_public_path__ + "static/media/profileEdit.afbe7e24.png";